import { useId, type DetailedHTMLProps, type LabelHTMLAttributes, type PropsWithChildren, type ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import { FormLabelForContext } from "@/contexts/FormLabelForContext";

export function FormField({
  title, // TODO: rename this prop to `label`
  className,
  children,
  htmlFor,
  ...props
}: PropsWithChildren<
  { className?: string; title: ReactNode } & Omit<
    DetailedHTMLProps<LabelHTMLAttributes<HTMLLabelElement>, HTMLLabelElement>,
    "title"
  >
>) {
  const id = useId();
  const titleId = useId();

  return (
    <FormLabelForContext value={htmlFor ?? id}>
      <label
        className={twMerge("flex flex-col gap-1", className)}
        htmlFor={htmlFor ?? id}
        {...props}
        aria-labelledby={titleId}
      >
        <div className="font-hint" id={titleId}>
          {title}
        </div>
        {children}
      </label>
    </FormLabelForContext>
  );
}
